var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.stickyAddToCart
      ? _c(
          "div",
          {
            staticClass: "d-flex justify-content-start align-items-center",
            class: [{ "has-crossprice": _vm.hasCrossPrice }],
          },
          [
            _c(
              "span",
              {
                staticClass: "price mr-1",
                class: { "is-special-offer": _vm.hasSpecialOffer },
              },
              [
                _c(
                  "span",
                  { staticClass: "font-weight-bolder" },
                  [
                    _vm.showDynamicPrice
                      ? [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.dynamicVariationPrice",
                                  {
                                    price: _vm.$options.filters.currency(
                                      _vm.variationTotalPrice,
                                      _vm.currentVariation.prices.default
                                        .currency
                                    ),
                                  }
                                )
                              ) +
                              "\n                "
                          ),
                        ]
                      : [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.currentVariation.prices.default.currency
                              )
                            ),
                          ]),
                          _c("span", { staticClass: "mb-0" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("currency")(_vm.variationTotalPrice, "")
                              )
                            ),
                          ]),
                        ],
                  ],
                  2
                ),
              ]
            ),
            _vm._v(" "),
            _vm.showCrossPrice && _vm.hasCrossPrice
              ? _c(
                  "div",
                  {
                    staticClass: "crossprice",
                    class: { "is-special-offer": _vm.hasSpecialOffer },
                  },
                  [
                    _c(
                      "del",
                      { staticClass: "text-muted text-appearance" },
                      [
                        _vm.hasSpecialOffer
                          ? [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm._f("itemCrossPrice")(
                                      _vm.currentVariation.prices.default
                                        .unitPrice.formatted,
                                      true
                                    )
                                  ) +
                                  "\n                "
                              ),
                            ]
                          : [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$translate(
                                      "GonserDT::Template.itemUvp",
                                      {
                                        price: _vm.$options.filters.currency(
                                          _vm.currentVariation.prices.rrp
                                            .unitPrice.value,
                                          " "
                                        ),
                                      }
                                    )
                                  ) +
                                  "\n                "
                              ),
                            ],
                      ],
                      2
                    ),
                  ]
                )
              : _vm._e(),
          ]
        )
      : _c("div", { class: [{ "has-crossprice": _vm.hasCrossPrice }] }, [
          _vm.hasCrossPrice &&
          _vm.currentVariation.prices.rrp &&
          _vm.currentVariation.prices.rrp.unitPrice.value > 0 &&
          _vm.currentVariation.prices.rrp.unitPrice.value >
            _vm.currentVariation.prices.default.unitPrice.value
            ? _c("div", { staticClass: "text-danger font-weight-bold" }, [
                _vm.hasSpecialOffer
                  ? _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$translate("GonserDT::Template.itemYouSave", {
                            value: Math.floor(
                              ((_vm.currentVariation.prices.rrp.unitPrice
                                .value -
                                _vm.currentVariation.prices.specialOffer
                                  .unitPrice.value) /
                                _vm.currentVariation.prices.rrp.unitPrice
                                  .value) *
                                100
                            ),
                          })
                        ) + "\n            "
                      ),
                    ])
                  : _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$translate("GonserDT::Template.itemYouSave", {
                            value: Math.floor(
                              ((_vm.currentVariation.prices.rrp.unitPrice
                                .value -
                                _vm.currentVariation.prices.default.unitPrice
                                  .value) /
                                _vm.currentVariation.prices.rrp.unitPrice
                                  .value) *
                                100
                            ),
                          })
                        ) + "\n            "
                      ),
                    ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "price",
              class: { "is-special-offer": _vm.hasSpecialOffer },
            },
            [
              _c(
                "span",
                [
                  _vm.showDynamicPrice
                    ? [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$translate(
                                "Ceres::Template.dynamicVariationPrice",
                                {
                                  price: _vm.$options.filters.currency(
                                    _vm.variationTotalPrice,
                                    _vm.currentVariation.prices.default.currency
                                  ),
                                }
                              )
                            ) +
                            "\n                "
                        ),
                      ]
                    : [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.currentVariation.prices.default.currency)
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticClass:
                              "h1 text-danger font-weight-bolder mb-0 ml-n1",
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("currency")(_vm.variationTotalPrice, "")
                              )
                            ),
                          ]
                        ),
                      ],
                ],
                2
              ),
            ]
          ),
          _vm._v(" "),
          _vm.showCrossPrice && _vm.hasCrossPrice
            ? _c(
                "div",
                {
                  staticClass: "crossprice",
                  class: { "is-special-offer": _vm.hasSpecialOffer },
                },
                [
                  _c(
                    "del",
                    { staticClass: "text-muted text-appearance" },
                    [
                      _vm.hasSpecialOffer
                        ? [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm._f("itemCrossPrice")(
                                    _vm.currentVariation.prices.default
                                      .unitPrice.formatted,
                                    true
                                  )
                                ) +
                                "\n                "
                            ),
                          ]
                        : [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$translate("GonserDT::Template.itemUvp", {
                                    price: _vm.$options.filters.currency(
                                      _vm.currentVariation.prices.rrp.unitPrice
                                        .value,
                                      " "
                                    ),
                                  })
                                ) +
                                "\n                "
                            ),
                          ],
                    ],
                    2
                  ),
                ]
              )
            : _vm._e(),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }